import {IPLocation} from "./IPLocation";
let $ = jQuery;

export class IPLocationService {
    public getCurrentLocation() : Promise<IPLocation> {
        return new Promise((resolve: (x: IPLocation) => void, reject) =>
            $.getJSON("https://api.ipstack.com/check?access_key=28566e3e1b1e006ddcab99afb5887cfa&output=json&legacy=1", (data) => resolve(data))
        );
    }
}





// WEBPACK FOOTER //
// ./assets/ts/src/services/location/IPLocationService.ts